import WaitingDots from 'components/WaitingDots';
import React, { useEffect } from 'react';
import { RootState } from "store/store";
import { getServices } from "store/actions/Services";
import { connect } from "react-redux";
import { ServicesState } from 'store/reducers/Services';
import { bindActionCreators } from 'redux';
import {useOfficeTranslation} from 'i18n/OfficeTranslation';

interface Props {
    servicesState: ServicesState;
}

interface Actions {
    getServices: () => void;
}

const ServiceStatusBanner: React.FC<Props & Actions> = ({ servicesState, getServices }) => {
    const {t} = useOfficeTranslation();


    useEffect(() => {
        getServices()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getServices])


    if (servicesState.getServices() === undefined) {
        return <WaitingDots />
    }

    let errors = 0;

    servicesState.getServices().forEach(service => service.checks.forEach(check => {
        if (check.last_result) {
            if (!check.last_result.ok) {
                errors = errors + 1;
            }
        }
    }))

    return (<>
        {errors > 0 ?
            <div className="alert alert-warning fade show" role="alert" style={{ display: "flex" }}>
                <span className="bx bx-error-alt bx-sm" style={{ display: "flex" }} />
                <div style={{ display: "flex", marginLeft: '10px', fontSize: "16px", fontWeight: "lighter" }}>
                    {t("services.serviceStatusBanner.minorServiceDisruptions")}
                </div>
            </div>
            :
            <>
                <div className="alert alert-success fade show" role="alert" style={{ display: "flex" }}>
                    <span className="bx bx-check-shield bx-sm" style={{ display: "flex" }} />
                    <div style={{ display: "flex", marginLeft: '10px', fontSize: "17px", fontWeight: "lighter" }}>
                        {t("services.serviceStatusBanner.allSystemsOperational")}
                    </div>
                </div>
            </>
        }
    </>
    );
}

const mapStateToProps = (state: RootState) => {
    return {
        servicesState: state.Services
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ getServices }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(ServiceStatusBanner);
